import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCommon } from "@obg/common.config";
import { ConfigService } from "@obg/ngx.global";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class KycConfig {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCommon>) {}

	getGenericVerificationEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isGenericVerificationEnabled, false);
	}

	getAgeVerificationEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isAgeVerificationEnabled, false);
	}

	getVerificationThroughDepositEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isVerificationThroughDepositEnabled, false);
	}

	getIsSmartIdVerificationEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isSmartIdEnabled, false);
	}

	getIsFullyVerificationBarEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isfullyVerificationBarEnabled, false);
	}

	getFullyVerificationBarTimeout() {
		return this.configService.get((x) => x.common.kycVerification?.fullyVerificationBarTimeout, 60000);
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.dispatch(AccountAppCommand.GetDepositThresholdEnabled)" instead
	 */
	isDepositThresholdEnabled$(): Observable<boolean | undefined> {
		return this.configService.get$((x) => x.common.kycVerification?.isDepositThresholdEnabled, false);
	}

	getDocumentExpiredEnabled() {
		return this.configService.get((x) => x.common.kycVerification?.isDocumentExpiredEnabled, false);
	}
}
